import { render, staticRenderFns } from "./Trending.vue?vue&type=template&id=185de059&scoped=true"
import script from "./Trending.vue?vue&type=script&lang=js"
export * from "./Trending.vue?vue&type=script&lang=js"
import style0 from "./Trending.vue?vue&type=style&index=0&id=185de059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185de059",
  null
  
)

export default component.exports